import { FieldTypes } from '../../constants'
import { addFieldRow } from '../../fields'
import { DropdownField, FieldMap, NumberField, TextAreaField } from '../../types'
import { ContractionIntensity, ContractionRestingTone } from '../types'

const frequencyField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Frequency',
  unit: 'min',
  min: 0,
  max: 30,
  step: 0.5,
  precision: 1,
}

const durationField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Duration',
  unit: 'sec',
  min: 0,
  max: 300,
}

const intensityField: DropdownField<ContractionIntensity> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Intensity',
  inputType: 'radio',
  options: [
    { text: 'Mild', id: ContractionIntensity.MILD },
    { text: 'Moderate', id: ContractionIntensity.MODERATE },
    { text: 'Strong', id: ContractionIntensity.STRONG },
    { text: 'Very Strong', id: ContractionIntensity.VERY_STRONG },
  ],
}

const restingToneField: DropdownField<ContractionRestingTone> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Resting Tone',
  inputType: 'radio',
  options: [
    { text: 'Soft', id: ContractionRestingTone.SOFT },
    { text: 'Firm', id: ContractionRestingTone.FIRM },
    { text: 'Hypertonic', id: ContractionRestingTone.HYPERTONIC },
  ],
}

const collectedViaField: DropdownField<'manual' | 'instrument'> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Collected Via',
  inputType: 'radio',
  options: [
    { text: 'Manual (palpation)', id: 'manual' },
    { text: 'Instrument (tocometer)', id: 'instrument' },
  ],
}

const notesField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Notes',
  optional: true,
}

export const contractionField: FieldMap = {
  name: 'Contraction',
  children: {
    frequency: addFieldRow(frequencyField, { index: 0, flex: 1 }),
    duration: addFieldRow(durationField, { index: 0, flex: 1 }),
    intensity: addFieldRow(intensityField, { index: 1, flex: 1 }),
    restingTone: addFieldRow(restingToneField, { index: 1, flex: 1 }),
    collectedVia: collectedViaField,
    notes: notesField,
  },
}
